import React, { useEffect, useState } from 'react';
import { Badge, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { OKRButton } from '../../Common/OKRButton';
import { DeleteIcon } from '../../../config/svg/CommonSvgIcon';
import '../../../styles/pages/admin/settings/default-okr/default-okr-listing.scss';
import { CalendarIcon } from '../../../config/svg/CommonSvgIcon';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthDateYear, getUserDetails } from '../../../config/utils';
import { SettingsIcon } from '../../../config/svg/MyGoalSvg';
import { MainDrawer } from '../../Admin/CommonComponent/MainDrawer';
import { DefaultKpiAttributes } from './CreateDefaultKpis/DefaultKpiAttributes';
import { Enums } from '../../../config/enums';
import AlertDialog from '../../Common/Dialog';
import { deleteUserKpi, setKpiListReload, updateKpiKey } from '../../../action/MyKpis';
import { useSnackbar } from 'notistack';
import { ConversationIcon } from '../../../config/svg/CommonSvg';
import { Cfr } from '../../Goals/Cfr';
import { OKRDrawer } from '../../Common/OKRDrawer';
import {
	addConversation,
	deleteConversation,
	getConversation,
	likeConversation,
	UpdateConversation,
} from '../../../action/cfr';
export const KpiActions: React.FC<any> = (props: any) => {
	const {
		keyDetails,
		isAllowToSendApproval,
		krIndex,
		showLoader,
		mode = 'Add',
		defaultOkrFormDetails,
		setDefaultOkrFormDetails,
		setShowLoader,
		newKeyList,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [keyData, setKeyData] = useState<any>({ ...keyDetails });
	const [openDefaultKrDrawer, setOpenDefaultKrDrawer] = useState<any>({ open: false, details: null });
	const [selectedDefaultKrTab, setSelectedDefaultKrTab] = useState<any>(0);
	const [selectedCycleDetails, setSelectedCycleDetails] = useState<any>(null);
	const [krAttributeEdited, setKrAttributeEdited] = useState<boolean>(false);
	const { enqueueSnackbar } = useSnackbar();
	const { conversationList, getConversationStatus } = useSelector((state: any) => state.cfrReducer);
	const [openCFR, setOpenCFR] = useState<boolean>(false);
	const [isCfrUpdated, setIsCfrUpdated] = useState<boolean>(false);
	const [modalCfrData, setModalCfrData] = useState<any>({ type: 1, okr: {}, kr: {}, taggedUser: {} });
	const [isTaskModified, setIsTaskModified] = useState<boolean>(false);
	const [unsavedCfrProps, setUnsavedCfrProps] = React.useState<any>({ open: false, event: null, source: '' });
	const loggedInUserDetail = getUserDetails();
	const { highlightedId } = useSelector((state: any) => state.kpiReducer);

	useEffect(() => {
		if (
			highlightedId?.conversationId &&
			highlightedId?.conversationId !== 0 &&
			mode === 'Edit' &&
			keyDetails &&
			keyDetails?.goalKeyId === highlightedId?.kpiKrId
		) {
			handleCfrOpen(
				{},
				5,
				{ ...keyData, highlightedId: highlightedId?.conversationId },
				krIndex,
				'conversation',
				{},
				keyData.managerDetails
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [highlightedId]);

	useEffect(() => {
		setShowLoader && setShowLoader(false);
		setKeyData({ ...keyDetails });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [keyDetails]);
	const [modalPerformanceProps, setModalPerformanceProps] = useState<any>({
		open: false,
		message: '',
		details: '',
		type: '',
	});
	const handleKrDrawerOpen = (e: any, krItem: any, krIndex: number) => {
		setOpenDefaultKrDrawer({ open: true, details: { krItem, krIndex, isAllowToSendApproval } });
	};
	const handleTabChange = (event: React.ChangeEvent<HTMLInputElement>, newValue: Number) => {
		event.preventDefault();
		setSelectedDefaultKrTab(newValue);
	};

	const checkDisableButton = () => {
		const isDisable = !keyData?.metricId
			? true
			: keyData?.metricId === Enums.TWO && !keyData?.currencyId
			? true
			: false;

		return isDisable;
	};

	const validateKrDrawerData = (krDetails: any) => {
		//Validate target and start value
		if (!krDetails?.keyDescription || krDetails?.keyDescription?.trim() === '') {
			const data = {
				isKrNameError: true,
				krNameErrorMsg: t('addKpiTitle'),
			};
			setKeyData({ ...keyData, ...data });

			return false;
		} else if (!krDetails.metricId) {
			const data = {
				isMetricTypeError: true,
				krMetricTypeErrorMsg: t('metricTypeRequired'),
				isMetricCurrencyError: false,
				krMetricCurrencyErrorMsg: '',
				isKrNameError: false,
				krNameErrorMsg: '',
			};
			setKeyData({ ...keyData, ...data });

			return false;
		} else if (krDetails.metricId === Enums.TWO && !krDetails?.currencyId) {
			const data = {
				isMetricTypeError: false,
				krMetricTypeErrorMsg: '',
				isMetricCurrencyError: true,
				krMetricCurrencyErrorMsg: t('currencyRequired'),
				isKrNameError: false,
				krNameErrorMsg: '',
			};
			setKeyData({ ...keyData, ...data });

			return false;
		} else if (!krDetails.targetValue && !krDetails.startValue) {
			const data = {
				isExpand: true,
				isTargetValueError: true,
				krTargetValueErrorMsg: t('targetValueRequired'),
			};
			setKeyData({ ...keyData, ...data });
			return false;
		} else if (krDetails.targetValue == krDetails.startValue) {
			const data = {
				isExpand: true,
				isTargetValueError: true,
				krTargetValueErrorMsg: t('startTargetNotSame'),
			};
			setKeyData({ ...keyData, ...data });
			return false;
		}
		return true;
	};
	const deleteExtraRecord = (keyDetails: any) => {
		delete keyDetails.isMetricTypeError;
		delete keyDetails.krMetricTypeErrorMsg;
		delete keyDetails.isMetricCurrencyError;
		delete keyDetails.krMetricCurrencyErrorMsg;
		delete keyDetails.isKrNameError;
		delete keyDetails.krNameErrorMsg;
	};
	const isSendForApproval = () => {
		const hasChanges =
			keyDetails?.metricId !== keyData?.metricId ||
			keyDetails?.targetValue !== keyData?.targetValue ||
			keyDetails?.currencyId !== keyData?.currencyId ||
			keyDetails?.startValue !== keyData?.startValue;

		return (
			isAllowToSendApproval === true &&
			keyDetails.kpiType === 1 &&
			// Allow enabling button if there are changes, even in pending state
			(keyDetails.krStatusId === 1 || keyDetails.krStatusId === 4) &&
			hasChanges
		);
	};
	const showMsg = (variant: any, messages: any) => {
		enqueueSnackbar(messages || `Error occurred while fetching comments`, {
			variant: variant || 'success',
			autoHideDuration: 3000,
		});
	};
	const handleKrDrawerClose = async (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
		try {
			if (type === 'save') {
				if (validateKrDrawerData(keyData)) {
					if (mode === 'Add') {
						const { krIndex } = openDefaultKrDrawer?.details;
						const { myGoalsDetails } = defaultOkrFormDetails || {};
						let updatedDefaultGoalKeys = myGoalsDetails && myGoalsDetails?.length ? [...myGoalsDetails] : [];
						updatedDefaultGoalKeys = updatedDefaultGoalKeys.map((rec: any, indexVal: number) => {
							if (krIndex === indexVal) {
								if (keyData) {
									deleteExtraRecord(keyData);
									return {
										...keyData,
										isKrEdited: true,
									};
								} else {
									deleteExtraRecord(rec);
									return { ...rec };
								}
							} else {
								deleteExtraRecord(rec);
								return { ...rec };
							}
						});
						setDefaultOkrFormDetails({
							...defaultOkrFormDetails,
							myGoalsDetails: [...updatedDefaultGoalKeys],
						});
						setKrAttributeEdited(false);
						setOpenDefaultKrDrawer({ open: false, details: null });
					} else {
						if (isSendForApproval()) {
							keyData.krStatusId = 1;
						} else {
							keyData.krStatusId = 2;
						}
						const response: any = await dispatch(updateKpiKey(keyData));
						if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
							const { messageList } = response?.data || {};
							const keys = messageList ? Object.keys(messageList) : [];
							const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
							showMsg('success', messages || `Performance improvement plan rights settings updated successfully.`);
							dispatch(setKpiListReload(true));
							setKrAttributeEdited(false);
							setOpenDefaultKrDrawer({ open: false, details: null });
						} else {
							const { messageList } = response?.data || {};
							const keys: any = messageList ? Object.keys(messageList) : null;
							const messages = keys && keys?.length ? keys.map((item: any) => messageList[item]) : [];
							showApiMsg('error', messages || 'Error occurred while fetching default okr details');
						}
					}
				}
			} else if (type === 'close' || type === 'cancel') {
				if (krAttributeEdited) {
					// Need to show unSave popup
					setModalPerformanceProps({ open: true, message: t('unSavedItemAlert'), details: '', type: 'KrAttribute' });
				} else {
					setOpenDefaultKrDrawer({ open: false, details: null });
					setKrAttributeEdited(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const showApiMsg = (variant: any, msg: any) => {
		enqueueSnackbar(msg || 'Error occurred while fetching default okr details', {
			variant: variant || 'error',
			autoHideDuration: 3000,
		});
	};
	const handleCfrOpen = (
		event: any,
		type: number,
		kr: any,
		okr: any,
		tabToOpen?: string,
		taggedUser = {},
		userData = {}
	) => {
		if (Boolean(okr) || Boolean(kr)) {
			setOpenCFR(true);
			setModalCfrData({
				type: type,
				okr: okr,
				kr: { ...kr, source: kr.goalKeyId },
				taggedUser: taggedUser,
				userData: [userData],
			});
		}
	};
	const getConversationData = (data: any) => {
		dispatch(getConversation(data));
	};
	const addConversationData = (data: any) => {
		return dispatch(addConversation(data));
	};
	const updateConversationData = (data: any) => {
		return dispatch(UpdateConversation(data));
	};
	const likeConversationData = (data: any) => {
		return dispatch(likeConversation(data));
	};
	const deleteConversationData = (data: any) => {
		return dispatch(deleteConversation(data));
	};

	const handleCfrDrawerClose = (event: any, type: string) => {
		event.preventDefault();
		event.stopPropagation();
		if (type === 'save') {
			event.preventDefault();
			setOpenCFR(false);
			if (modalCfrData.type === 1 && modalCfrData?.okr?.isUnreadConversation === true) {
				modalCfrData.okr.isUnreadConversation = false;
			} else if (modalCfrData.type === 2 && modalCfrData?.kr?.isUnreadConversation === true) {
				modalCfrData.kr.isUnreadConversation = false;
			}
			//props.resetConversation();
			//props.resetNotes();
		} else if (type === 'cancel') {
			if (isTaskModified) {
				setUnsavedCfrProps({ open: true, event: null, source: 'close' });
			} else {
				setOpenCFR(false);
				setUnsavedCfrProps({ open: false, event: null, source: '' });
			}
		}
	};
	const isButtonDisabled = () => {
		// Disable button if in pending state (krStatusId === 1) with no changes
		if (keyDetails.krStatusId === 1 && !isSendForApproval()) {
			return true;
		}
		// Otherwise, check other conditions
		return checkDisableButton() || keyData.isEditable === false;
	};
	const handlePerformanceCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalPerformanceProps?.type === 'KrAttribute') {
				setKeyData(null);
				setOpenDefaultKrDrawer({ open: false, message: '', details: null });
			} else if (modalPerformanceProps?.type === 'KRDelete') {
				const { item, indexValue } = modalPerformanceProps?.details;

				if (mode === 'Add' || !item?.goalKeyId) {
					const { myGoalsDetails } = defaultOkrFormDetails;
					if (myGoalsDetails && myGoalsDetails?.length) {
						const updatedDefaultGoalKeys = myGoalsDetails.filter(
							(rec: any, itemIndex: number) => itemIndex !== indexValue
						);
						setDefaultOkrFormDetails({ ...defaultOkrFormDetails, myGoalsDetails: updatedDefaultGoalKeys });
					}
				} else {
					let data = `goalType=2&goalId=${item.goalKeyId}`;

					dispatch(deleteUserKpi(data));

					dispatch(setKpiListReload(true));
				}
			}

			setModalPerformanceProps({ open: false, message: '', details: '', type: '' });
		} else {
			setModalPerformanceProps({ open: false, message: '', details: '', type: '' });
		}
	};
	const handleKRDeletionClick = (event: any, krItem: any, krIndex: number) => {
		try {
			setModalPerformanceProps({
				open: true,
				message: t('deleteKpiMessage'),
				details: {
					item: krItem,
					indexValue: krIndex,
					mode: mode,
				},
				type: 'KRDelete',
			});
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<>
			{keyData?.publishedOn ? (
				<Box className='set-timeline-area'>
					<Box className='timeline-field'>
						<Box className='calendar-btn'>
							<OKRButton
								title={t('publishedOn')}
								text={keyData?.publishedOn ? `${getMonthDateYear(keyData?.publishedOn)}` : ''}
								icon={<CalendarIcon />}
								disabled={true}
							/>
						</Box>
					</Box>
				</Box>
			) : (
				<></>
			)}

			<Box className='okr-field-actions'>
				<OKRButton
					className={`settings-btn ${
						keyData?.isMetricTypeError || keyData?.isMetricCurrencyError ? 'settings-btn-error' : ''
					}`}
					id='default-obj-setting-btn'
					icon={<SettingsIcon />}
					handleClick={(e) => {
						handleKrDrawerOpen(e, keyDetails, krIndex);
					}}
					title={t('okrHoverText')}
					tooltipClassName={`tooltip-layout3 ${
						keyData?.isMetricTypeError || keyData?.isMetricCurrencyError ? 'tooltip-error-new' : ''
					}`}
					openTooltip={keyData?.isMetricTypeError || keyData?.isMetricCurrencyError}
				/>
				{(keyData?.isEditable && keyData.isDeletable) || mode === 'Add' ? (
					<OKRButton
						className='delete-btn'
						id='objective-delete-btn'
						icon={<DeleteIcon />}
						title={t('delete')}
						handleClick={(e) => {
							handleKRDeletionClick(e, keyData, krIndex);
						}}
					/>
				) : (
					<></>
				)}
				{(keyData?.krStatusId === 2 || keyData?.krStatusId === 1) && keyData?.krStatusIdName !== 'Draft' && (
					<OKRButton
						className={`conversation-btn`}
						wrapClassName={'conversation-btn-wrap'}
						icon={<ConversationIcon />}
						handleClick={(e: any) => {
							handleCfrOpen(e, 5, keyData, krIndex, 'conversation', {}, keyData.managerDetails);
							setOpenCFR(true);
						}}
						title={t('conversationLabel')}
					/>
				)}
			</Box>

			{openDefaultKrDrawer && openDefaultKrDrawer?.open ? (
				<MainDrawer
					open={openDefaultKrDrawer.open}
					drawerClassName={'main-drawer-panel main-drawer-titlepanel default-kr-attribute-panel'}
					transitionDuration={{ enter: 500, exit: 1000 }}
					headerTitle={t('kpiAttributes')}
					loader={false}
					children={
						<Box className='drawer-inner-content'>
							<DefaultKpiAttributes
								{...props}
								mode={mode}
								defaultOkrFormDetails={defaultOkrFormDetails}
								krDetails={openDefaultKrDrawer?.details ? openDefaultKrDrawer?.details : null}
								selectedDefaultKrTab={selectedDefaultKrTab}
								handleTabChange={handleTabChange}
								// selectedKrDateRange={selectedKrDateRange}
								// setSelectedKrDateRange={setSelectedKrDateRange}
								selectedKrCycleDetails={selectedCycleDetails}
								setSelectedKrCycleDetails={setSelectedCycleDetails}
								keyData={keyData}
								setKeyData={setKeyData}
								krAttributeEdited={krAttributeEdited}
								setKrAttributeEdited={setKrAttributeEdited}
							/>
						</Box>
					}
					isSaveButtonDisabled={isButtonDisabled()}
					saveButtonText={
						keyDetails.krStatusId === 1 && !isSendForApproval()
							? t('Send for Approval')
							: isSendForApproval()
							? t('Send for Approval')
							: t('Submit')
					}
					handleDrawerClose={(event: any) => handleKrDrawerClose(event, 'close')}
					handleSaveClick={(event: any) => handleKrDrawerClose(event, 'save')}
					handleCancelClick={(event: any) => handleKrDrawerClose(event, 'cancel')}
				/>
			) : (
				<></>
			)}

			{modalPerformanceProps && modalPerformanceProps.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={false}
					message={modalPerformanceProps?.message || ''}
					handleCloseModal={handlePerformanceCloseModal}
					modalOpen={modalPerformanceProps.open}
				/>
			)}
			{openCFR && (
				<OKRDrawer
					open={openCFR}
					drawerClassName={'main-drawer-panel main-drawer-titlepanel ok-cfr-panel'}
					transitionDuration={{ enter: 500, exit: 1000 }}
					headerTitle={''}
					drawerHead={false}
					children={
						<Cfr
							isCfrUpdated={isCfrUpdated}
							setIsCfrUpdated={setIsCfrUpdated}
							{...props}
							kr={modalCfrData.kr}
							okr={modalCfrData.okr}
							type={modalCfrData.type}
							taggedUser={modalCfrData.taggedUser}
							userListingData={modalCfrData.userData}
							useStaticData={true}
							setIsTaskModified={setIsTaskModified}
							openCFR={openCFR}
							setOpenCFR={setOpenCFR}
							setUnsavedCfrProps={setUnsavedCfrProps}
							unsavedCfrProps={unsavedCfrProps}
							getConversation={getConversationData}
							addConversation={addConversationData}
							UpdateConversation={updateConversationData}
							likeConversation={likeConversationData}
							deleteConversation={deleteConversationData}
							conversationList={conversationList}
							getConversationStatus={getConversationStatus}
							selectTab={'conversation'}
						/>
					}
					moreButton={false}
					handleDrawerClose={(event: any) => handleCfrDrawerClose(event, 'cancel')}
					handleSaveClick={(event: any) => handleCfrDrawerClose(event, 'save')}
					handleCancelClick={(event: any) => handleCfrDrawerClose(event, 'cancel')}
					hideDefaultButton={true}
					isAnyDrawerOpened={props.isAnyDrawerOpened}
					appDrawerInfo={props.appDrawerInfo}
				/>
			)}
		</>
	);
};
